// extracted by mini-css-extract-plugin
export default {"mainMenu":"main-menu_mainMenu__UICEI","stroke":"main-menu_stroke__uowlr","fill":"main-menu_fill__FDLrn","active":"main-menu_active__pO7LN"};